export default {"src":"/sitetest/_next/static/media/contact_icon.c6ea7781.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};